import "./style.css";

import { TextInput } from "@mantine/core";
import { IconCalendarWeek } from "@tabler/icons-react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker, { DateObject } from "react-multi-date-picker";

import type { DatePickerProps } from "./type";

const CustomDatePicker = (DatePicker as unknown as { default?: typeof DatePicker }).default ?? DatePicker;

export default function PersianDatePicker({
  onChange,
  placeholder,
  disabled,
  label,
  error,
  withAsterisk,
  ...rest
}: DatePickerProps) {
  const formatDate = (dateObject: DateObject) =>
    [dateObject.year, dateObject.month, dateObject.day]
      .map((item) => item.toString().padStart(2, "0"))
      .join("/");

  const onChangeHandler = (dateObject: DateObject) => {
    if (dateObject) {
      onChange(formatDate(dateObject));
    } else {
      onChange("");
      return;
    }
  };

  return (
    <CustomDatePicker
      onChange={onChangeHandler}
      containerStyle={{ width: "100%" }}
      calendar={persian}
      locale={persian_fa}
      {...rest}
      render={(value, openCalendar) => (
        <TextInput
          label={label}
          onFocus={openCalendar}
          value={value}
          readOnly
          onClick={openCalendar}
          rightSection={<IconCalendarWeek size={18} />}
          disabled={disabled}
          placeholder={placeholder}
          error={error}
          aria-label={label}
          withAsterisk={withAsterisk}
          size="sm"
        />
      )}
    />
  );
}
